import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { DropdownShell, IconTile, SmartLink } from "./NavPrimitives";

/** Generic dropdown: titled columns of icon + label + description links. */
export default function LinksPanel({ navKey, menu, onNavigate }) {
  const cols = menu.columns.length;
  return (
    <DropdownShell align={menu.align} width={menu.width} testid={`nav-dropdown-${navKey}`}>
      <div className={`grid gap-px bg-slate-100 ${cols === 3 ? "grid-cols-3" : cols === 2 ? "grid-cols-2" : "grid-cols-1"}`}>
        {menu.columns.map((col) => (
          <div key={col.title} className="bg-white p-4">
            <div className="mono text-[10px] tracking-[0.22em] uppercase text-slate-500 pb-2 mb-2 border-b border-slate-100">
              {col.title}
            </div>
            <ul className="space-y-0.5">
              {col.items.map((it) => (
                <li key={it.key}>
                  <SmartLink
                    to={it.to}
                    href={it.href}
                    onClick={onNavigate}
                    data-testid={`nav-${navKey}-item-${it.key}`}
                    className="group flex items-center gap-3 -mx-1.5 px-1.5 py-1.5 rounded-sm hover:bg-paper-dark/40 transition-colors"
                  >
                    <IconTile icon={it.icon} />
                    <span className="min-w-0">
                      <span className="block text-[13px] font-semibold text-slate-900 group-hover:text-topo transition-colors">
                        {it.label}
                      </span>
                      <span className="block text-[11px] text-slate-500 truncate">{it.desc}</span>
                    </span>
                  </SmartLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {menu.footer && (
        <div className="border-t border-slate-200 bg-paper-dark/30 px-4 py-2.5 flex justify-end">
          <Link
            to={menu.footer.to}
            onClick={onNavigate}
            data-testid={`nav-${navKey}-footer-link`}
            className="inline-flex items-center gap-1 text-sm font-semibold text-topo hover:text-orange-survey transition-colors"
          >
            {menu.footer.label} <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      )}
    </DropdownShell>
  );
}
